export enum EelPfc {
  AESITN = 'AES_ITN',
  NOEEI3036 = 'NOEEI_30_36',
  NOEEI3037A = 'NOEEI_30_37_a',
  NOEEI3037F = 'NOEEI_30_37_f',
  NOEEI3037H = 'NOEEI_30_37_h',
}

export enum ContentsType {
  DOCUMENTS = 'DOCUMENTS',
  GIFT = 'GIFT',
  'HUMANITARIAN_DONATION' = 'HUMANITARIAN_DONATION',
  MERCHANDISE = 'MERCHANDISE',
  OTHER = 'OTHER',
  'RETURN_MERCHANDISE' = 'RETURN_MERCHANDISE',
  SAMPLE = 'SAMPLE',
}

export const ContentsTypeOptionsMap = {
  [ContentsType.DOCUMENTS]: ContentsType.DOCUMENTS,
  [ContentsType.GIFT]: ContentsType.GIFT,
  [ContentsType.HUMANITARIAN_DONATION]: ContentsType.HUMANITARIAN_DONATION,
  [ContentsType.MERCHANDISE]: ContentsType.MERCHANDISE,
  [ContentsType.OTHER]: ContentsType.OTHER,
  [ContentsType.RETURN_MERCHANDISE]: ContentsType.RETURN_MERCHANDISE,
  [ContentsType.SAMPLE]: ContentsType.SAMPLE,
};

export enum Incoterm {
  DDP = 'DDP',
  DDU = 'DDU',
  FCA = 'FCA',
}

export enum NonDelivery {
  ABANDON = 'ABANDON',
  RETURN = 'RETURN',
}

export enum B13AFilingOption {
  FILED_ELECTRONICALLY = 'FILED_ELECTRONICALLY',
  NONE_SELECTED = 'None',
  NOT_REQUIRED = 'NOT_REQUIRED',
  SUMMARY_REPORTING = 'SUMMARY_REPORTING',
}

export const B13AFilingOptionMap: Record<string, B13AFilingOption> = {
  [B13AFilingOption.FILED_ELECTRONICALLY]: B13AFilingOption.FILED_ELECTRONICALLY,
  [B13AFilingOption.NONE_SELECTED]: B13AFilingOption.NONE_SELECTED,
  [B13AFilingOption.NOT_REQUIRED]: B13AFilingOption.NOT_REQUIRED,
  [B13AFilingOption.SUMMARY_REPORTING]: B13AFilingOption.SUMMARY_REPORTING,
};

interface B13FilingOptionNumber {
  label: string;
  regex: RegExp;
  regexDisplay: string;
}
export const B13AFilingOptionNumberMap: Record<string, B13FilingOptionNumber> = {
  [B13AFilingOption.FILED_ELECTRONICALLY]: {
    label: 'B13A Proof of Report Number',
    regex: /^[A-Z]{2}[0-9]{13,23}$/,
    regexDisplay: 'AA####YYYYMMDDN, where N is 1 to 11 digits',
  },
  [B13AFilingOption.NOT_REQUIRED]: {
    label: 'B13A Exemption Number',
    regex: /^NDR[0-9]{1,2}$/,
    regexDisplay: 'NDR##',
  },
  [B13AFilingOption.SUMMARY_REPORTING]: {
    label: 'B13A Summary ID Number',
    regex: /^SUM[0-9]{4}$/,
    regexDisplay: 'SUM####',
  },
};

export enum TaxIDTypes {
  EIN = 'EIN',
  IOSS = 'IOSS',
  VAT = 'VAT',
}

export const TaxIDTypeVATMaxLength = 15;
export const TaxIDTypeEINMaxLength = 9;

export const ValidationMessagesMap = {
  aesItn: {
    invalid: 'Expected format: X12345678901234',
    required: 'Please enter a value for AES / ITN',
    tooLong: 'This field cannot be longer than 15 characters',
  },
  b13aFilingOption: {
    invalid: 'Please choose a valid B13A Filing Option',
  },
  b13aNumber: {
    invalid: (format: string) =>
      format ? `Expected format: ${format}` : 'Please enter a valid value',
    required: (label: string) => `Please enter a value for ${label || 'B13A Number'}`,
  },
  certificate: {
    tooLong: 'This field cannot be longer than 12 characters',
  },
  certifySigner: {
    required: 'Please enter a value for signing person',
    tooLong: 'This field cannot be longer than 100 characters',
  },
  contentsExplanation: {
    required: 'Please enter a value for content explanation',
    tooLong: 'This field cannot be longer than 20 characters',
  },
  contentsType: {
    required: 'Please choose type of content',
  },
  eoriNumber: {
    invalid: 'Expected format: PL1234567890ABCDEFG',
    tooLong: 'This field cannot be longer than 19 characters',
  },
  exporterReference: {
    tooLong: 'This field cannot be longer than 50 characters',
  },
  importerReference: {
    tooLong: 'This field cannot be longer than 50 characters',
  },
  isCertify: {
    required: 'You must certify the validity of the information provided',
  },
  license: {
    tooLong: 'This field cannot be longer than 15 characters',
  },
  notes: {
    tooLong: 'This field cannot be longer than 200 characters',
  },
  taxIdNumber: {
    invalid: (label: string) => {
      if (label === TaxIDTypes.VAT || label === TaxIDTypes.IOSS)
        return 'Expected format: AA12345678AAA';
      else return 'Expected format: 123456789';
    },
    required: (label: string) => `Please enter a value for ${label}`,
    tooLong: (maxLength: number) => `This field cannot be longer than ${maxLength} characters`,
  },
};
